import { $createListItemNode, $createListNode } from '@lexical/list';
import { RICH_TEXT_NODES } from '@plato/shared-util/lexical-config';
import {
    $createParagraphNode,
    $createTextNode,
    $getRoot,
    createEditor,
    type SerializedEditorState,
} from 'lexical';
import type { SuggestedText } from '../../../server/queries/improve-writing-suggest-query.ts';

type Section = {
    heading: string;
    items: string[];
};

function hasContent(items: string[] | null | undefined): items is string[] {
    return Array.isArray(items) && items.length > 0 && items.join('').trim() !== '';
}

export function suggestedTextToLexical(
    response: SuggestedText,
    headings: {
        summary: string;
        opportunities: string;
        feedback: string;
        nextSteps: string;
    },
): SerializedEditorState | null {
    const sections: Section[] = [];
    if (hasContent(response.summary)) {
        sections.push({ heading: headings.summary, items: response.summary });
    }
    if (hasContent(response.opportunities)) {
        sections.push({ heading: headings.opportunities, items: response.opportunities });
    }
    if (hasContent(response.feedback)) {
        sections.push({ heading: headings.feedback, items: response.feedback });
    }
    if (hasContent(response.next_steps)) {
        sections.push({ heading: headings.nextSteps, items: response.next_steps });
    }

    if (sections.length === 0) {
        return null;
    }

    const editor = createEditor({
        nodes: RICH_TEXT_NODES,
        onError: (error) => {
            console.error('suggestedTextToLexical error:', error);
        },
    });

    editor.update(
        () => {
            const root = $getRoot();
            root.clear();
            for (const section of sections) {
                const heading = $createParagraphNode();
                const headingText = $createTextNode(section.heading);
                headingText.setFormat('bold');
                heading.append(headingText);
                root.append(heading);

                const list = $createListNode('bullet');
                for (const item of section.items) {
                    const li = $createListItemNode();
                    const p = $createParagraphNode();
                    p.append($createTextNode(item));
                    li.append(p);
                    list.append(li);
                }
                root.append(list);
            }
        },
        { discrete: true },
    );

    return editor.getEditorState().toJSON();
}
